import {
    $, addAction, doAction, INIT, GTM_INTERACTION,
} from '@situation/setdesign.util';

addAction(INIT, () => {
    $('.quiz_wrapper').each((_, wrapper) => {
        const $wrapper = $(wrapper);
        const $button = $wrapper.find('.gform_next_button').first();
        const formID = $wrapper.find('form[data-formid]').data('formid');
        if (!$button.length || !formID) {
            return;
        }

        $button.one('click', () => {
            doAction(GTM_INTERACTION, {
                type: 'quiz-start', formID, label: 'Instant Poll', $el: $button,
            });
        });
    });
});
